export class GoogleCustomer {
    id: string;
    name: string;
    email: string;
    firstName: string;
    lastName: string;
    idToken: string;
    authToken: string;
    provider: string;
    lattitude: string;
    longitude: string;
    phoneNo: string;
}
